function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMyheart24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Heart Normal",
  style: {
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M681.648 369.01a5.05 5.05 0 0 0-3.44 1.351q-.176.162-.336.341l-.88.95-.88-.95a5.06 5.06 0 0 0-7.219-.341q-.176.162-.336.341a6.13 6.13 0 0 0 0 8.179l.88.95 7.555 8.179 7.555-8.179.879-.95a6.125 6.125 0 0 0 0-8.179 5.06 5.06 0 0 0-3.779-1.692z",
  style: {
    stroke: "none"
  },
  transform: "translate(-664.994 -366.51)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.334 370.01a4.06 4.06 0 0 0-3.033 1.36 5.1 5.1 0 0 0-1.308 3.421 5.1 5.1 0 0 0 1.303 3.416l.876.945 6.82 7.384 7.696-8.33a5.1 5.1 0 0 0 1.304-3.415c0-1.27-.464-2.484-1.309-3.421a4.09 4.09 0 0 0-3.035-1.36 4.06 4.06 0 0 0-3.031 1.36l-.01.011-1.615 1.743-1.624-1.754a4.09 4.09 0 0 0-3.034-1.36m0-1c1.387 0 2.77.57 3.778 1.692l.88.95.88-.95a5.06 5.06 0 0 1 7.555 0 6.125 6.125 0 0 1 0 8.179l-.88.95-7.555 8.179-8.435-9.13a6.13 6.13 0 0 1 0-8.178 5.05 5.05 0 0 1 3.776-1.692z",
  style: {
    fill: "#d9d9d9",
    stroke: "none"
  },
  transform: "translate(-664.994 -366.51)"
})));
export default SvgIconMyheart24;